// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
    background-color: azure;
}

h1 {
    font-size: 45px;
    font-style: italic;
    text-decoration: underline;
}

input,
select,
option,
label {
    font-size: 30px;
    margin: 1rem;
}

#multih,
#multid,
#multim {
    width: 23%;
    display: inline-block;
    box-sizing: border-box;
    margin: 15px;
}

#submit {
    font-size: 32px;
    width: 10%;
    height: 10%;
    margin: 15px;
    border-radius: 2rem;
    background-color: aqua;
}

#horizontal_div {
    width: 100%;
    display: flex;
}
#multi_1 {
    margin-right: 30%;
}
`, "",{"version":3,"sources":["webpack://./src/components/orep.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,0BAA0B;AAC9B;;AAEA;;;;IAII,eAAe;IACf,YAAY;AAChB;;AAEA;;;IAGI,UAAU;IACV,qBAAqB;IACrB,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,UAAU;IACV,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,aAAa;AACjB;AACA;IACI,iBAAiB;AACrB","sourcesContent":["body {\n    background-color: azure;\n}\n\nh1 {\n    font-size: 45px;\n    font-style: italic;\n    text-decoration: underline;\n}\n\ninput,\nselect,\noption,\nlabel {\n    font-size: 30px;\n    margin: 1rem;\n}\n\n#multih,\n#multid,\n#multim {\n    width: 23%;\n    display: inline-block;\n    box-sizing: border-box;\n    margin: 15px;\n}\n\n#submit {\n    font-size: 32px;\n    width: 10%;\n    height: 10%;\n    margin: 15px;\n    border-radius: 2rem;\n    background-color: aqua;\n}\n\n#horizontal_div {\n    width: 100%;\n    display: flex;\n}\n#multi_1 {\n    margin-right: 30%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
